import { inject, signal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { useToaster } from 'app/shared/composables/use-toaster';

import { LinkRequestsStore } from '../link-requests.store';
import { LinkRequestOID } from '../models/LinkRequest';

export function useResendLinkRequest() {
    const linkRequests = inject(LinkRequestsStore);
    const translate = inject(TranslateService);
    const toaster = useToaster();

    const loading = signal(false);

    const resend = async (linkRequestOID: LinkRequestOID) => {
        if (loading()) return;

        loading.set(true);
        try {
            await linkRequests.resend(linkRequestOID);
        } catch {
            toaster.error({ title: translate.instant('ERROR_WHILE_SENDING_SITE_ASSIGNATION_REQUEST') });
            return;
        } finally {
            loading.set(false);
        }

        toaster.success({
            title: translate.instant('CMS_SITE_ASSIGNATION_TOASTER_SUCCESS_TITLE'),
            message: translate.instant('CMS_SITE_ASSIGNATION_TOASTER_SUCCESS_MESSAGE'),
        });
    };

    return { resend, loading };
}
